import { render, staticRenderFns } from "./emailList.vue?vue&type=template&id=3ed55b9e&scoped=true&"
import script from "./emailList.vue?vue&type=script&lang=js&"
export * from "./emailList.vue?vue&type=script&lang=js&"
import style0 from "./emailList.vue?vue&type=style&index=0&id=3ed55b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed55b9e",
  null
  
)

export default component.exports